module.exports = __webpack_public_path__ + "img/ico-arrow-back.e7a9b7f5.svg";